



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import { EBatchStatus, ESortOrder, EStatementStatuses, EUserPermissions, IStatement } from '@zunta/configurations'
import { DO_NOT_BILL_STATUSES, STATEMENT_MAILED_STATUSES, STATEMENT_STATUSES_LABEL_MAP } from '@/constants'
import { StatementModule } from '@/store/modules/statement.module'
import { getModule } from 'vuex-module-decorators'
import TrackingMail from '@/components/TrackingMail.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import GenerationAlertModal from '@/views/app/management/components/GenerationAlertModal.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType } from '@/interfaces'
import NoPrebillAlertModal from '@/views/app/management/components/NoPrebillAlertModal.vue'
import StatusStatement from '@/components/statuses/StatusStatement.vue'
import { BatchModule } from '@/store/modules/batch.module'

@Component({
  components: {
    StatusStatement,
    Table,
    GenerationAlertModal,
    TrackingMail,
    ResidentLabel,
    Icon,
    DateTimeLabel,
    NoPrebillAlertModal
  }
})
export default class StatementsList extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  paymentModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  batchModuleInstance: BatchModule = getModule(BatchModule, this.$store)
  user: User = Api.getUser() as User

  doNotBillStatuses: EStatementStatuses[] = DO_NOT_BILL_STATUSES

  EUserPermissions: any = EUserPermissions
  EStatementStatuses = EStatementStatuses

  trackingStatement: IStatement | null = null
  reviewAlertOptions: any = null

  shouldShowGenerationAlert: boolean = false
  ifNoPrebillItems: boolean = false
  shouldShowTracking: boolean = false
  isLoading: boolean = false
  generationAlertWasShown: boolean = false

  filters: any = {
    limit: 20,
    skip: 0,
    sortBy: 'residentName',
    sortOrder: ESortOrder.ASC
  }

  get config () {
    return {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      useQuery: true,
      usePagination: true,
      fetchFunction: this.fetchStatements,
      rowClick: this.goStatementReview,
      columns: [
        {
          minWidth: '150px',
          width: 20,
          key: 'residentName',
          searchKey: 'residentName',
          label: 'Resident',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 20,
          key: 'recipientName',
          searchKey: 'recipientName',
          label: 'Recipient',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '202px',
          width: 15,
          key: 'status',
          searchKey: 'status',
          label: 'Status',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.multiselect,
          options: this.statusesFilters
        },
        {
          minWidth: '150px',
          width: 15,
          key: 'billDate',
          searchKey: 'billDate',
          label: 'Bill Date',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.dateRange
        },
        {
          headClass: 'bt-justify-content-end',
          class: 'text-right',
          minWidth: '150px',
          width: 15,
          key: 'due',
          searchKey: 'due',
          label: 'Due',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.numberRange
        },
        {
          minWidth: '150px',
          width: 15,
          key: 'lastUpdate',
          searchKey: 'lastUpdate',
          label: 'Last Updated',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.dateRange
        },
        {
          minWidth: '30px',
          width: 5,
          key: 'actions'
        }
      ]
    }
  }

  get isUnmailed () {
    return this.$route.name === 'management-mailings-statements-batch-unmailed'
  }

  get batchID () {
    return this.$route.params.id
  }

  get dashboardStatistics () {
    return this.$store.state.statement.statementsBatchDashboardStatistics
  }

  get facilitiesPaymentsNotInSync () {
    return this.$store.state.payments.facilitiesPaymentsNotInSync
  }

  get getNewChargesIsGenerated () {
    return this.$store.state.statement.getNoPrebillItems || []
  }

  get statementListTotal () {
    return this.$store.state.statement.statementListTotal
  }

  get statementList () {
    return this.$store.state.statement.statementList
  }

  get mailStatements () {
    return this.$store.state.statement.mailStatements
  }

  get mailStatementsSum () {
    return this.mailStatements ? this.mailStatements.deliverToRoom + this.mailStatements.paperless + this.mailStatements.mailed : 0
  }

  get unmailedStatusesFilter () {
    const arr = [
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.RETURNED],
        key: EStatementStatuses.RETURNED,
        value: EStatementStatuses.RETURNED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.EMAIL_RETURNED],
        key: EStatementStatuses.EMAIL_RETURNED,
        value: EStatementStatuses.EMAIL_RETURNED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.NEEDS_FIX],
        key: EStatementStatuses.NEEDS_FIX,
        value: EStatementStatuses.NEEDS_FIX
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.NEEDS_REVIEW],
        key: EStatementStatuses.NEEDS_REVIEW,
        value: EStatementStatuses.NEEDS_REVIEW
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.READY_TO_MAIL],
        key: EStatementStatuses.READY_TO_MAIL,
        value: EStatementStatuses.READY_TO_MAIL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.READY_TO_EMAIL],
        key: EStatementStatuses.READY_TO_EMAIL,
        value: EStatementStatuses.READY_TO_EMAIL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.READY_TO_PRINT],
        key: EStatementStatuses.READY_TO_PRINT,
        value: EStatementStatuses.READY_TO_PRINT
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL],
        key: EStatementStatuses.DO_NOT_BILL,
        value: EStatementStatuses.DO_NOT_BILL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_NEGATIVE],
        key: EStatementStatuses.DO_NOT_BILL_NEGATIVE,
        value: EStatementStatuses.DO_NOT_BILL_NEGATIVE
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_ZERO],
        key: EStatementStatuses.DO_NOT_BILL_ZERO,
        value: EStatementStatuses.DO_NOT_BILL_ZERO
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_CONTROL],
        key: EStatementStatuses.DO_NOT_BILL_CONTROL,
        value: EStatementStatuses.DO_NOT_BILL_CONTROL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_PERMANENTLY],
        key: EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
        value: EStatementStatuses.DO_NOT_BILL_PERMANENTLY
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_RETURNED],
        key: EStatementStatuses.DO_NOT_BILL_RETURNED,
        value: EStatementStatuses.DO_NOT_BILL_RETURNED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED],
        key: EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED,
        value: EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED
      }
    ]
    if (this.isFcc) {
      arr.push({
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.ALREADY_SENT],
        key: EStatementStatuses.ALREADY_SENT,
        value: EStatementStatuses.ALREADY_SENT
      })
    }
    return arr
  }

  get statusesFilters () {
    return this.isUnmailed
      ? this.unmailedStatusesFilter
      : this.mailingStatusesFilter
  }

  get isFcc () {
    return (this.selectedBatch && this.selectedBatch.facility && this.selectedBatch.facility.isFcc) || false
  }

  get selectedBatch () {
    return this.$store.state.batch.selectedBatch
  }

  get mailingStatusesFilter () {
    return [
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DELIVERED],
        key: EStatementStatuses.DELIVERED,
        value: EStatementStatuses.DELIVERED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.REROUTED],
        key: EStatementStatuses.REROUTED,
        value: EStatementStatuses.REROUTED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.IN_TRANSIT],
        key: EStatementStatuses.IN_TRANSIT,
        value: EStatementStatuses.IN_TRANSIT
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.IN_LOCALAREA],
        key: EStatementStatuses.IN_LOCALAREA,
        value: EStatementStatuses.IN_LOCALAREA
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.IN_PROCESS],
        key: EStatementStatuses.IN_PROCESS,
        value: EStatementStatuses.IN_PROCESS
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.PRINTED_LOCALLY],
        key: EStatementStatuses.PRINTED_LOCALLY,
        value: EStatementStatuses.PRINTED_LOCALLY
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.PROCESSED_FOR_DELIVERY],
        key: EStatementStatuses.PROCESSED_FOR_DELIVERY,
        value: EStatementStatuses.PROCESSED_FOR_DELIVERY
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.PENDING],
        key: EStatementStatuses.PENDING,
        value: EStatementStatuses.PENDING
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.EMAILED],
        key: EStatementStatuses.EMAILED,
        value: EStatementStatuses.EMAILED
      }
    ]
  }

  async mounted () {
    await this.checkDisplayPopup()
  }

  async fetchStatements (filters: any) {
    await this.statementModuleInstance.getBatchStatementListByFilters({
      filters: {
        ...filters,
        mailed: this.isUnmailed ? 'unmailed' : 'mailed'
      },
      batchId: this.batchID
    })
  }

  async goStatementReview (statement: IStatement) {
    if (!this.user.hasPermissionFor(EUserPermissions.REVIEW_STATEMENTS)) {
      return
    }

    this.reviewAlertOptions = {
      name: 'review-statements',
      params: {
        batch: this.batchID,
        type: 'mailed',
        statement: statement.id.toString()
      },
      query: {
        defaultType: statement.status ? statement.status : 'ALL'
      }
    }

    if (!STATEMENT_MAILED_STATUSES.includes(statement.status)) {
      this.reviewAlertOptions = {
        name: 'review-statements',
        params: {
          batch: this.batchID,
          type: 'unmailed',
          statement: statement.id.toString()
        },
        query: {
          defaultType: statement.status ? statement.status : 'ALL'
        }
      }
    }
    this.goToPage(this.reviewAlertOptions)
  }

  showTrackerIcon (statement: IStatement) {
    return !!statement.dateMailed && (!!statement.lobLetterId || !!statement.trackingNumber)
  }

  goToPage (options: any) {
    this.batchModuleInstance.toggleBatchAlert(false)
    this.$locationManager.rememberAndGoTo(options)
  }

  openTracker (statement: IStatement) {
    this.trackingStatement = statement
    this.shouldShowTracking = true
  }

  async checkDisplayPopup () {
    if (!this.selectedBatch || this.selectedBatch.status === EBatchStatus.COMPLETE) {
      return
    }
    if (!this.$store.state.batch.showBatchAlerts) {
      return
    }
    if (!this.generationAlertWasShown) {
      this.$eventBus.$emit('loading:enable', { message: 'Loading' })
      await this.paymentModuleInstance.fetchBatchPaymentsNotInSync(this.selectedBatch.id)
      this.$eventBus.$emit('loading:disable')
      if (this.facilitiesPaymentsNotInSync.length > 0) {
        this.shouldShowGenerationAlert = true
        this.generationAlertWasShown = true
        return
      }
    }
    await this.statementModuleInstance.fetchNewChargesIsGenerated(this.selectedBatch.id)
    if (this.getNewChargesIsGenerated.length > 0 && !this.selectedBatch.missingPayerChargesConfirmed) {
      this.ifNoPrebillItems = true
    }
  }

  async closeGenerationAlert () {
    this.shouldShowGenerationAlert = false
    this.generationAlertWasShown = true
    await this.checkDisplayPopup()
  }

  beforeDestroy () {
    this.batchModuleInstance.toggleBatchAlert(false)
  }
}
